export const redirectToHome = () => (window.location.href = "/");
